import {NEW_SEQUENCE} from 'constants/action-types.js';
import {SET_RESOLUTION} from 'constants/action-types.js';
import {SET_SEQUENCER_ENGINE} from 'constants/action-types.js';
import {SET_VIEW_MODE} from 'constants/action-types.js';
import {SET_ALTERNATE_VIEW_MODE} from 'constants/action-types.js';
import {SET_DETAILS_VIEW} from 'constants/action-types.js';
import {SET_DECENTRALIZED} from 'constants/action-types.js';
import {SET_SELECTOR_MODE} from 'constants/action-types.js';
import {SET_NUMBER_PATTERNS} from 'constants/action-types.js';
import {SET_CURRENT_PATTERN} from 'constants/action-types.js';
import {SET_CURRENT_STEP} from 'constants/action-types.js';
import {SET_CURRENT_AND_GLOBAL_STEPS} from 'constants/action-types.js';
import {SET_CURRENT_GLOBAL_STEP} from 'constants/action-types.js';

// tracks
import {NEW_TRACK} from 'constants/action-types.js';

// samples
import {SET_SAMPLE} from 'constants/action-types.js';

// animation triggers 
import {START_TRIGGER_TRACK} from 'constants/action-types.js';
import {STOP_TRIGGER_TRACK} from 'constants/action-types.js';

// sample packs
import {SET_SAMPLE_PACK} from 'constants/action-types.js';
import {ADD_SAMPLE_PACK} from 'constants/action-types.js';
import {REMOVE_SAMPLE_PACK} from 'constants/action-types.js';

import {DRAG_SAMPLE} from 'constants/action-types.js';
import {DRAG_EFFECT} from 'constants/action-types.js';
import {DRAG_PATTERN} from 'constants/action-types.js';

import {MOUSE_DOWN} from 'constants/action-types.js';
import {DRAG_TOGGLE} from 'constants/action-types.js';
import {DRAG_STEP_TRANSPOSE} from 'constants/action-types.js';
import {COMMAND_DOWN} from 'constants/action-types.js';

import {TRACK_RECORDING} from 'constants/action-types.js';
import {TRACK_PREPARING_TO_RECORD} from 'constants/action-types.js';

import {SET_TRACK_STEPS} from 'constants/action-types.js';
import {SET_TRACK_FILLS} from 'constants/action-types.js';
import {SET_TRACK_PIANO_ROLL_STEPS} from 'constants/action-types.js';
import {SET_ALL_TRACK_STEPS} from 'constants/action-types.js';

import {SET_SELECTED_GROUP} from 'constants/action-types.js';
import {SET_SELECTED_TRACK} from 'constants/action-types.js';
import {SET_SELECTED_STEP} from 'constants/action-types.js';
import {SET_HOVERED_STEP} from 'constants/action-types.js';

import {SET_STEP_DRAGGING} from 'constants/action-types.js';
import {SET_STEP_DATA_DRAGGING} from 'constants/action-types.js';
import {SET_STEP_AND_DATA_DRAGGING} from 'constants/action-types.js';
import {SET_STEP_TO_COPY} from 'constants/action-types.js';

import {SET_TRACK_VOLUME} from 'constants/action-types.js';
import {SET_TRACK_MUTED} from 'constants/action-types.js';
import {SET_TRACK_SOLO} from 'constants/action-types.js';

import {SET_GROUP_VOLUME} from 'constants/action-types.js';
import {SET_GROUP_MUTED} from 'constants/action-types.js';

import {SET_QUANTIZED} from 'constants/action-types.js';
import {SET_IS_RECORDING} from 'constants/action-types.js';
import {SET_IS_RECORDING_EXPANDED} from 'constants/action-types.js';
import {SET_IS_RECORDING_MIX} from 'constants/action-types.js';
import {SET_IS_PLAYING} from 'constants/action-types.js';
import {SET_IS_PLAYING_MIX} from 'constants/action-types.js';

import {SET_SEND_MUTED} from 'constants/action-types.js';

import {SET_SELECTION} from 'constants/action-types.js';

import {SET_SEQUENCE_NAME} from 'constants/action-types.js';

import {SET_SELECTED_EFFECT} from 'constants/action-types.js';

import {SET_EFFECT_PARAMETER_VALUE} from 'constants/action-types.js';

import {SET_EFFECTS_PANE_OPTION} from 'constants/action-types.js';

import {SET_SELECTED_PARAMETER} from 'constants/action-types.js';
import {SET_SHOW_LOGIN} from 'constants/action-types.js';
import {SET_USER_TOKEN} from 'constants/action-types.js';
import {SET_SIGNING_UP} from 'constants/action-types.js';

import {SET_SELECTED_PARAMETER_FLASHING} from 'constants/action-types.js';

import {SET_MIXES} from 'constants/action-types.js';
import {SET_CURRENT_MIX} from 'constants/action-types.js';
import {SET_ERASING_AUTOMATION} from 'constants/action-types.js';

import {SET_TRACK_SEND_VOLUME} from 'constants/action-types.js';

import {SET_TRACK_FOCUSED} from 'constants/action-types.js';

import {SET_YEAR_SELECTED} from 'constants/action-types.js';
import {SET_TAGS_SELECTED} from 'constants/action-types.js';
import {SET_STYLES_SELECTED} from 'constants/action-types.js';
import {SET_COUNTRIES_SELECTED} from 'constants/action-types.js';
import {SET_VIDEOS_SELECTED} from 'constants/action-types.js';
import {SET_HIERARCHY_ROOT} from 'constants/action-types.js';
import {SET_HIERARCHY_TREE} from 'constants/action-types.js';
import {SET_SHOW_YEAR_SLIDER} from 'constants/action-types.js';
import {SET_SHOW_COUNTRIES} from 'constants/action-types.js';
import {SET_SHOW_VIDEOS} from 'constants/action-types.js';
import {SET_SHOW_STYLES} from 'constants/action-types.js';
import {SET_SHOW_TAGS} from 'constants/action-types.js';
import {SET_SHOW_CHORD_FILTER} from 'constants/action-types.js';
import {SET_CHORD_SELECTED} from 'constants/action-types.js';

import {SET_IS_DRAGGING_DURATION} from 'constants/action-types.js';
import {SET_PIANO_ROLL_SELECTION} from 'constants/action-types.js';
import {SET_SELECTED_PIANO_ROLL_STEPS} from 'constants/action-types.js';

import {SET_SEARCH_RESULTS_SAMPLES} from 'constants/action-types.js';

import {SET_SELECTED_CHORD_SAMPLE} from 'constants/action-types.js';
import {SET_STEPS_TO_COPY} from 'constants/action-types.js';

import {SET_LOADING_SEQUENCE} from 'constants/action-types.js';

import {SET_EASY_PATTERN_TO_COPY} from 'constants/action-types.js';
import {SET_SAMPLE_AUDITIONING} from 'constants/action-types.js';

import {SET_LAST_MIDI_KEY_MAPPED} from 'constants/action-types.js';
import {SET_TRACK_IS_ENABLED} from 'constants/action-types.js';

import {SET_SELECTED_SAMPLE_TAG} from 'constants/action-types.js';

import {SET_TRANSPOSE_DRAGGING} from 'constants/action-types.js';

import {SET_MASTER_VOLUME} from 'constants/action-types.js';

import {SET_USER_VIEW_MODE} from 'constants/action-types.js';
import {SET_CURRENT_USER_MIX} from 'constants/action-types.js';
import {SET_USER_HAS_EDITS_TO_SAVE} from 'constants/action-types.js';

import {SET_PATTERN_TO_EDIT_COLOR} from 'constants/action-types.js';
import {SET_PATTERN_COLOR} from 'constants/action-types.js';

import {SET_COMPACT_MODE} from 'constants/action-types.js';
import {SET_SHOW_LFOS} from 'constants/action-types.js';
import {SET_SHOW_ENVELOPES} from 'constants/action-types.js';

import {SET_TRACKS_TO_RESAMPLE} from 'constants/action-types.js';

import {SET_PROJECT_AUTOMATION_MODE} from 'constants/action-types.js';

import {SET_STEPS_SELECTION} from 'constants/action-types.js';
import {SET_SELECTED_STEPS} from 'constants/action-types.js';
import {SET_STEP_NUMBER_DRAGGING_FROM} from 'constants/action-types.js';

import {SET_SEQUENCE_PATTERN_LOCKED} from 'constants/action-types.js';
import {SET_SEQUENCE_PATTERN_LOCKS} from 'constants/action-types.js';

import {SET_TRACK_PATTERN_LOCKED} from 'constants/action-types.js';
import {SET_TRACK_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_EFFECT_PATTERN_LOCKS} from 'constants/action-types.js';
import {UPDATE_STEPS_FOR_ALL_TRACKS} from 'constants/action-types.js';
import {SET_LFO_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_ENVELOPE_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_PIANO_ROLL_PAGINATION} from 'constants/action-types.js';

import {SET_IS_RESAMPLING} from 'constants/action-types.js';
import {SET_RESAMPLE_DURATION} from 'constants/action-types.js';

import {SET_KEY_MAPPINGS} from 'constants/action-types.js';
import {SET_PAD_MAPPINGS} from 'constants/action-types.js';

import {SET_SHOW_SEQUENCE_MODAL} from 'constants/action-types.js';

import {SET_MULTI_PARAMETER_SLIDER} from 'constants/action-types.js';

import {SET_SHOW_MODS_MODAL} from 'constants/action-types.js';

import {SET_SEQUENCE_ROLLING} from 'constants/action-types.js';

import {SET_TRACK_EFFECTS_CHAIN} from 'constants/action-types.js';

import {SET_SHOW_SEQUENCES} from 'constants/action-types.js';
import {SET_SHOW_PRESETS} from 'constants/action-types.js';
import {SET_SHOW_INSTRUMENTS} from 'constants/action-types.js';
import {SET_TRACK_ROLLING} from 'constants/action-types.js';

import {SET_Z_INDEX_HACK} from 'constants/action-types.js';

import {SET_LOADED_TRACKS} from 'constants/action-types.js';
import {SET_BPM} from 'constants/action-types.js';
import {SET_RESAMPLE_MASTER} from 'constants/action-types.js';

import {SET_YOUTUBE_SEARCH_TERMS} from 'constants/action-types.js';

import {SET_AUDIO_INPUT_SOURCE} from 'constants/action-types.js';

import {SET_WAVEFORM_SELECTION} from 'constants/action-types.js';
import {SET_WAVEFORM_SELECTION_END} from 'constants/action-types.js';

import {SET_MIDI_MAP_MODE} from 'constants/action-types.js';
import {SET_PARAMETER_MIDI_MAP_SELECTION} from 'constants/action-types.js';
import {DELETE_PARAMETER_MIDI_MAPPING} from 'constants/action-types.js';
import {SET_PARAMETER_MIDI_MAPPING} from 'constants/action-types.js';

import {SET_ACTION_MIDI_MAP_SELECTION} from 'constants/action-types.js';
import {DELETE_MIDI_MAPPINGS} from 'constants/action-types.js';
import {SET_ACTION_MIDI_MAPPING} from 'constants/action-types.js';

import {SET_LATENCY} from 'constants/action-types.js';

import {SET_SPOTLIGHT_TRACKS} from 'constants/action-types.js';

import {SET_CLOCK_TYPE} from 'constants/action-types.js';
import {SET_CLOCK_TICK} from 'constants/action-types.js';
import {SET_CONNECTION_STATUS} from 'constants/action-types.js';
import {SET_CONNECTED_USER_NAME} from 'constants/action-types.js';
import {SET_PLAY_SCHEDULED} from 'constants/action-types.js';
import {SET_AVAILABLE_USERS_TO_SYNC} from 'constants/action-types.js';

import {SET_SEARCH_SORT_BY} from 'constants/action-types.js';

import {SET_MIDI_EFFECT_DRAGGING} from 'constants/action-types.js';

import {SET_SHOW_TRACK_EFFECTS} from 'constants/action-types.js';

import {SET_SHOW_CONVOLVER_MODAL} from 'constants/action-types.js';
import {SET_SHOW_PASSWORD_MODAL} from 'constants/action-types.js';
import {SET_PASSWORD_MODAL_CALLBACK} from 'constants/action-types.js';

import {SET_SHOW_SHARE_SEQUENCE_MODAL} from 'constants/action-types.js';

import {HIDE_ALL_EFFECTS} from 'constants/action-types.js';

import {SET_EFFECT_COLLAPSED} from 'constants/action-types.js';

import {SET_CONTEXTUAL_HELP} from 'constants/action-types.js';

import {SET_SELECTED_LFO} from 'constants/action-types.js';
import {SET_SELECTED_ENVELOPE} from 'constants/action-types.js';
import {SET_SIDEBAR_COLLAPSED} from 'constants/action-types.js';

import {SET_MIX_EVENTS} from 'constants/action-types.js';

import {SET_SHOW_GROUPS} from 'constants/action-types.js';

import {SET_CURRENT_SUB_SEQUENCE} from 'constants/action-types.js';
import {SET_SUB_SEQUENCES} from 'constants/action-types.js';

import {SET_ALL_TRACK_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_ALL_LFO_LOCKS} from 'constants/action-types.js';
import {SET_ALL_ENVELOPE_LOCKS} from 'constants/action-types.js';

import {SET_MIX_VIEW_MODE} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_FADE} from 'constants/action-types.js';

import {SET_SAMPLE_SLICES} from 'constants/action-types.js';

import {SET_SELECTED_ARRANGEMENT_EVENTS} from 'constants/action-types.js';

import {SET_SHOW_DATE_SAMPLED} from 'constants/action-types.js';
import {SET_DATE_SAMPLED} from 'constants/action-types.js';

import {SET_EFFECT_PARAMETER_VALUES} from 'constants/action-types.js';

import {SET_TRACK_PANNING} from 'constants/action-types.js';
import {SET_GROUP_PANNING} from 'constants/action-types.js';
import {SET_SENDS_PANNING} from 'constants/action-types.js';

import {SET_SELECTED_RECORD} from 'constants/action-types.js';
import {SET_2D_SELECTION} from 'constants/action-types.js';
import {SET_SIMILAR_SOUNDS_TO_FIND} from 'constants/action-types.js';
import {SET_SHOW_SAMPLES_2D} from 'constants/action-types.js';
import {SET_LAST_NOTE_PLAYED} from 'constants/action-types.js';
import {SET_SIDEBAR_VIEW_MODE} from 'constants/action-types.js';
import {SET_DISCOGS_SELECTED} from 'constants/action-types.js';
import {SET_SELECTED_FOLDER} from 'constants/action-types.js';
import {SET_SELECTED_PRESET} from 'constants/action-types.js';
import {SET_HAS_CHANGES_TO_FOLDERS} from 'constants/action-types.js';

import {SET_CURSOR_STEP} from 'constants/action-types.js';
import {SET_CURSOR_TRACK} from 'constants/action-types.js';
import {SET_CURSOR_SHOW} from 'constants/action-types.js';
import {SET_FOLDER_DRAGGING} from 'constants/action-types.js';
import {SET_PRESET_DRAGGING} from 'constants/action-types.js';
import {SET_SAMPLE_DRAGGING} from 'constants/action-types.js';
import {SET_EFFECTS_CHAIN_TO_SHOW} from 'constants/action-types.js';
import {SET_EFFECTS_CHAINS_TO_SHOW} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_MUTED} from 'constants/action-types.js';
import {SET_TRACK_FROZEN} from 'constants/action-types.js';
import {SET_TRACK_TO_FREEZE} from 'constants/action-types.js';
import {SET_FROZEN_TRACK_PLAYING} from 'constants/action-types.js';
import {SET_FROZEN_TRACKS} from 'constants/action-types.js';
import {SET_FROZEN_TRACKS_PLAYING} from 'constants/action-types.js';
import {SET_SELECTED_ONSETS} from 'constants/action-types.js';

import {SET_SINGLE_STEP_TO_DRAG} from 'constants/action-types.js';
import {SET_STEP_NUMBER_DRAGGED_TO} from 'constants/action-types.js';
import {SET_SEARCH_RESULTS_START} from 'constants/action-types.js';
import {SET_SHOW_STEP_OPTIONS} from 'constants/action-types.js';
import {SET_MASTER_STEP_TOGGLES} from 'constants/action-types.js';
import {SET_PARAMETERS_TO_RECORD} from 'constants/action-types.js';
import {SET_ONSET_THRESHOLD} from 'constants/action-types.js';
import {SET_SHOW_ONSETS} from 'constants/action-types.js';

import {SET_SELECTED_GUILD} from 'constants/action-types.js';
import {SET_PIANO_ROLL_DRAG_OFFSET} from 'constants/action-types.js';
import {SET_PIANO_ROLL_NOTES} from 'constants/action-types.js';

import {SET_PENDING_TRANSACTIONS} from 'constants/action-types.js';
import {SET_COMMAND_INPUT} from 'constants/action-types.js';
import {SET_COMMAND_PREFIX} from 'constants/action-types.js';
import {SET_VI_MODE} from 'constants/action-types.js';
import {SET_TRACK_WARP} from 'constants/action-types.js';
import {SET_SUB_SEQUENCE_WARPS} from 'constants/action-types.js';

import {SET_ARRANGEMENT_SELECTION} from 'constants/action-types.js';
import {SET_ARRANGEMENT_MOUSE_X} from 'constants/action-types.js';
import {SET_ARRANGEMENT_AUTOMATION_TO_SHOW} from 'constants/action-types.js';
import {SET_ARRANGEMENT_LOOPING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_SELECTED_ROWS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_LOOP_SELECTED} from 'constants/action-types.js';
import {SET_ARRANGEMENT_ROW_SELECTIONS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_ZOOM} from 'constants/action-types.js';

import {SET_SELECTED_SEQUENCE} from 'constants/action-types.js';
import {SET_EXPLORE_MIXER_EFFECT} from 'constants/action-types.js';
import {SET_EXPLORE_EQ_EFFECT} from 'constants/action-types.js';
import {SET_SELECTED_SEND_EFFECT} from 'constants/action-types.js';
import {SET_INSTRUMENT_TYPE_DRAGGING} from 'constants/action-types.js';

import {SET_TRACK_IS_LOADING} from 'constants/action-types.js';

import {SET_PIANO_ROLL_CURSOR} from 'constants/action-types.js';
import {SET_ARRANGEMENT_X_SCALE} from 'constants/action-types.js';
import {SET_TOTAL_ARRANGEMENT_LENGTH} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_HEIGHT} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_MODE} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BOTTOM_RESIZING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_DRAGGING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_START_STEP} from 'constants/action-types.js';
import {SET_ARRANGEMENT_CURSOR_STEP} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_RESIZING} from 'constants/action-types.js';
import {SET_ARRANGEMENT_BROWSER_MODE} from 'constants/action-types.js';
import {SET_SAMPLE_TO_EXPLORE} from 'constants/action-types.js';
import {SET_EFFECT_RACK_NODE_POSITION} from 'constants/action-types.js';
import {SET_ANNOTATION_DRAGGING} from 'constants/action-types.js';

import {SET_TRACK_AUTOMATION_DEVICE} from 'constants/action-types.js';
import {SET_TRACK_AUTOMATION_SUB_DEVICE} from 'constants/action-types.js';
import {SET_TRACK_AUTOMATION_RACK_DEVICE} from 'constants/action-types.js';
import {SET_TRACK_AUTOMATION_PARAMETER} from 'constants/action-types.js';
import {SET_SHOW_AUTOMATION} from 'constants/action-types.js';
import {SET_PARAMETER_AUTOMATIONS} from 'constants/action-types.js';

import {SET_ACTIONS_REMAINING} from 'constants/action-types.js';
import {SET_TIME_REMAINING} from 'constants/action-types.js';

import {SET_SHOW_PIANO_ROLL} from 'constants/action-types.js';
import {SET_SELECTED_RACK_SUB_TRACK} from 'constants/action-types.js';
import {DELETE_AUTOMATIONS_FOR_PARAMETERS} from 'constants/action-types.js';
import {SET_AUTOMATION_GUIDE_POINT} from 'constants/action-types.js';
import {SET_AUTOMATION_POINT_DRAGGING} from 'constants/action-types.js';
import {SET_AUTOMATION_POINT_HAS_MOVED} from 'constants/action-types.js';
import {SET_AUTOMATION_POINT_HOVERED} from 'constants/action-types.js';
import {SET_TRACK_TO_CONVERT} from 'constants/action-types.js';
import {SET_AUTOMATION_POINTS_SELECTED} from 'constants/action-types.js';
import {SET_AUTOMATION_SELECTION} from 'constants/action-types.js';

import {SET_EXPLORE_PERSON_SELECTED} from 'constants/action-types.js';
import {SET_EXPLORE_ALL_SEQUENCES}from 'constants/action-types.js';

import {DELETE_AUTOMATIONS_FOR_ENGINE}from 'constants/action-types.js';
import {SET_RECORDING_EXPLORE_MIX} from 'constants/action-types.js';
import {SET_WORKS_LOADED} from 'constants/action-types.js';
import {SET_WORK_TRANSPOSE} from 'constants/action-types.js';
import {SET_WORK_VOLUME} from 'constants/action-types.js';
import {SET_EXPLORE_MIX_LOADED} from 'constants/action-types.js';

import {SET_IS_MACRO_MAPPING} from 'constants/action-types.js';
import {SET_PARAMETER_TO_MAP} from 'constants/action-types.js';

import {SET_MIX_COLOR_VALUE} from 'constants/action-types.js';
import {SET_MIX_HAS_EDITS} from 'constants/action-types.js';

import {SET_SCRIPT_VARIABLES} from 'constants/action-types.js';

import {SET_EXPLORE_OPTION} from 'constants/action-types.js';

import {SET_ANNOTATIONS_VIEW} from 'constants/action-types.js';
import {SET_EXPLORE_TOAST} from 'constants/action-types.js';

import {SET_PARAMETER_SLIDER_DOWN} from 'constants/action-types.js';
import {MOVE_ENGINE_AUTOMATIONS} from 'constants/action-types.js';
import {SET_SEQUENCE_LOADING_PROGRESS} from 'constants/action-types.js';

import {SET_TRACK_BROWSED_SAMPLES} from 'constants/action-types.js';
import {SET_TRACK_BROWSED_PRESETS} from 'constants/action-types.js';
import {SET_BOTTOM_TOOLBAR_OFFSET} from 'constants/action-types.js';
import {SET_TRACK_UPDATES} from 'constants/action-types.js';
import {SET_IS_TRANSCRIBING} from 'constants/action-types.js';
import {SET_SAMPLE_TOOLTIP} from 'constants/action-types.js';
import {SET_SELECTED_FREEZE} from 'constants/action-types.js';
import {SET_TRACK_LENGTH_MODE} from 'constants/action-types.js';
import {SET_TRACK_LENGTH_CHOICE} from 'constants/action-types.js';
import {SET_FREEZE_DRAGGING} from 'constants/action-types.js';
import {SET_FREEZE_COLUMN_SAMPLES} from 'constants/action-types.js';
import {SET_UPLOADING_FILE} from 'constants/action-types.js';
import {SET_GROUP_COLLAPSED} from 'constants/action-types.js';
import {SET_SELECTED_MIX_EFFECT} from 'constants/action-types.js';
import {SET_SAMPLES_DRAGGING} from 'constants/action-types.js';
import {SET_DISPLAY_RESOLUTION} from 'constants/action-types.js';
import {SET_OFFLINE_ENGINE} from 'constants/action-types.js';
import {SET_CURRENT_EXPORT_INFO} from 'constants/action-types.js';
import {SET_MIX_TRACK_DRAGGING} from 'constants/action-types.js';
import {SET_GROUP_TRACKS} from 'constants/action-types.js';
import {SET_LOADING_TEXT} from 'constants/action-types.js';
import {SET_TRACK_ENVELOPES} from 'constants/action-types.js';
import {SET_COPIED_NODES_FOR_RACK} from 'constants/action-types.js';
import {SET_LAST_MIDI_CC_PLAYED} from 'constants/action-types.js';
import {SET_ARRANGEMENT_MOUSE_DOWN_X} from 'constants/action-types.js';

import {SET_TRACKER_PARAMETER_TO_EDIT} from 'constants/action-types.js';
import {SET_TRACKS_TO_HIDE} from 'constants/action-types.js';
import {SET_SELECTED_PALETTE} from 'constants/action-types.js';
import {SET_SEQUENCED_PALETTE} from 'constants/action-types.js';
import {SET_PROJECT_DRAGGING} from 'constants/action-types.js';
import {SET_EXPLORE_UNPUBLISHED} from 'constants/action-types.js';
import {SET_QUICK_ADD_SEARCH_TEXT} from 'constants/action-types.js';
import {SET_SHOW_TRACK_FREEZE_HISTORY} from 'constants/action-types.js';
import {SET_SELECTED_MIDI_TRACK} from 'constants/action-types.js';
import {SET_SELECTED_TRACK_SLICE} from 'constants/action-types.js';
import {SET_CIRKLON_PARAMETER_SELECTED} from 'constants/action-types.js';
import {SET_CIRKLON_MODE} from 'constants/action-types.js';
import {SET_NOTES_DOWN} from 'constants/action-types.js';
import {SET_SCENES} from 'constants/action-types.js';
import {SET_CURRENT_SCENE} from 'constants/action-types.js';
import {SET_SHOW_SETTINGS} from 'constants/action-types.js';
import {SET_WALLPAPER} from 'constants/action-types.js';
import {SET_ANIMATE_WALLPAPER} from 'constants/action-types.js';
import {SET_EXPANDED_PROJECT} from 'constants/action-types.js';
import {SET_ACCUMULATOR_PARAMETER_SELECTED} from 'constants/action-types.js';
import {SET_PLANE_MAPPING} from 'constants/action-types.js';
import {SET_TRACK_PRESET_SAVING} from 'constants/action-types.js';
import {SET_SAMPLE_TAG_DRAGGING} from 'constants/action-types.js';
import {SET_PARAMETER_MIX_AUTOMATIONS} from 'constants/action-types.js';
import {SET_SHOW_ARRANGEMENT_TRACKS} from 'constants/action-types.js';
import {SET_ARRANGEMENT_PATTERN_SELECTED} from 'constants/action-types.js';
import {SET_SIDEBAR_SEARCH_INPUT} from 'constants/action-types.js';
import {SET_SHOW_ARRANGEMENT_SEARCHER} from 'constants/action-types.js';
import {SET_VI_SELECT_MODE} from 'constants/action-types.js';
import {SET_EXPLORE_WORK} from 'constants/action-types.js';
import {SET_CREATING_NEW_PACK} from 'constants/action-types.js';
import {SET_PACK_WINDOW_POSITION} from 'constants/action-types.js';
import {SET_DRAGGING_PACK_WINDOW} from 'constants/action-types.js';
import {SET_PACK_TO_EDIT} from 'constants/action-types.js';
import {SET_IS_MANAGING_GUILDS} from 'constants/action-types.js';

import {NEW_STEP_GROUP} from 'constants/action-types.js';
import {SET_STEPS_GROUP_MODE} from 'constants/action-types.js';
import {SET_TRANSFORMATION_EDGE_DRAGGING} from 'constants/action-types.js';
import {SET_SHOW_FORMANT_EFFECT} from 'constants/action-types.js';
import {SET_SHOWING_FORMANTS} from 'constants/action-types.js';
import {SET_PULLED_EFFECTS} from 'constants/action-types.js';
import {SET_LOOPS_TO_FREEZE} from 'constants/action-types.js';
import {SET_PARAMETER_MIN_MAX} from 'constants/action-types.js';
import {SET_CURRENT_SOUND_IN_LIST} from 'constants/action-types.js';
import {SET_SHOWING_SOUND_LIST} from 'constants/action-types.js';
import {SET_CURRENT_TAG_IN_LIST} from 'constants/action-types.js';
import {SET_LINKING_EFFECTS} from 'constants/action-types.js';
import {SET_PACK_SELECTED} from 'constants/action-types.js';
import {SET_SAMPLE_EXPLORER_SELECTED} from 'constants/action-types.js';
import {SET_PIANO_ROLL_SLIDE} from 'constants/action-types.js';
import {SET_MAXIMIZE_EXPLORER} from 'constants/action-types.js';

import {SET_PADS} from 'constants/action-types.js';
import {SET_PAD_SLOTS} from 'constants/action-types.js';
import {SET_PAD_HOVERED} from 'constants/action-types.js';
import {SET_WAVEFORM_SHOWING} from 'constants/action-types.js';
import {SET_TRACK_DRAGGING} from 'constants/action-types.js';
import {SET_HIDE_MIXER} from 'constants/action-types.js';
import {SET_SOURCE_EXPLORING} from 'constants/action-types.js';
import {SET_YEAR_EXPLORING} from 'constants/action-types.js';
import {SET_PULLABLE_PART_DRAGGING} from 'constants/action-types.js';
import {SET_PADS_EXPAND} from 'constants/action-types.js';

import {SET_SEQUENCERS} from 'constants/action-types.js';
import {SET_SEQUENCER_TRACKS} from 'constants/action-types.js';
import {SET_PLANE_MACROS} from 'constants/action-types.js';
import {SET_WINDOW_POSITION} from 'constants/action-types.js';
import {SET_BULK_WINDOW_POSITIONS} from 'constants/action-types.js';
import {SET_PAD_EFFECTS} from 'constants/action-types.js';
import {SET_DRAWING_PAD_EDGE} from 'constants/action-types.js';
import {SET_SELECTED_PAD_EDGE} from 'constants/action-types.js';
import {SET_BULK_EFFECTS_COLLAPSED} from 'constants/action-types.js';
import {SET_SELECTED_PULLED_ELEMENTS} from 'constants/action-types.js';
import {SET_ALL_EFFECT_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_MODULE_COLLAPSED} from 'constants/action-types.js';
import {SET_TRACK_MIDI_EFFECTS} from 'constants/action-types.js';
import {SET_EFFECT_STARRED} from 'constants/action-types.js';
import {SET_BULK_EFFECTS_STARRED} from 'constants/action-types.js';
import {SET_BULK_MODULES_COLLAPSED} from 'constants/action-types.js';
import {DELETE_TRACK_ID} from 'constants/action-types.js';

export const setResolution = resolution => ({ type: SET_RESOLUTION, payload: resolution });
export const setSequencerEngine = sequencerEngine => ({ type: SET_SEQUENCER_ENGINE, payload: sequencerEngine});
export const setViewMode = viewMode => ({ type: SET_VIEW_MODE, payload: viewMode});
export const setAlternateViewMode = viewMode => ({ type: SET_ALTERNATE_VIEW_MODE, payload: viewMode});
export const setDetailsView = trackNumber => ({ type: SET_DETAILS_VIEW, payload: trackNumber});
export const setDecentralized = decentralized => ({ type: SET_DECENTRALIZED, payload: decentralized});
export const setSelectorMode = selectorMode => ({ type: SET_SELECTOR_MODE , payload: selectorMode});
export const setNumberOfPatterns = (id, numberOfPatterns) => (
    {
        type: SET_NUMBER_PATTERNS,
        payload: {
            id,
            numberOfPatterns
        }
    });
export const setCurrentPattern =
    (sequenceId, currentPattern) =>
    ({
        type: SET_CURRENT_PATTERN ,
        payload: {
            sequenceId: sequenceId,
            currentPattern: currentPattern}});
export const setCurrentStep =
    (sequenceId, currentStep) =>
    ({
        type: SET_CURRENT_STEP ,
        payload: {
            sequenceId: sequenceId,
            currentStep: currentStep}});
export const setCurrentGlobalStep =
    (sequenceId, currentStep) =>
    ({
        type: SET_CURRENT_GLOBAL_STEP,
        payload: {
            sequenceId: sequenceId,
            currentGlobalStep: currentStep
        }
    });

export const setCurrentAndGlobalSteps =
    (sequenceId, currentStep, currentGlobalStep) =>
    ({
        type: SET_CURRENT_AND_GLOBAL_STEPS,
        payload: {
            sequenceId: sequenceId,
            currentStep: currentStep,
            currentGlobalStep: currentGlobalStep,
        }
    }
    );

// samples

export const setSample = (id, sample) => ({ type: SET_SAMPLE, payload: {sampleId: id, sample: sample}});

export const startTriggerTrack = (trackNumber, sliceNumber) => ({ type: START_TRIGGER_TRACK, payload: {trackNumber: trackNumber, sliceNumber: sliceNumber}});
export const stopTriggerTrack = (trackNumber, sliceNumber) => ({ type: STOP_TRIGGER_TRACK, payload: {trackNumber: trackNumber, sliceNumber: sliceNumber}});

export const setSamplePack = (samplePack) => ({ type: SET_SAMPLE_PACK , payload: samplePack});

// add sample pack to your palette
export const addSamplePack = (samplePack) => ({ type: ADD_SAMPLE_PACK , payload: samplePack});
export const removeSamplePack = (samplePack) => ({ type: REMOVE_SAMPLE_PACK , payload: samplePack});


export const dragSample = (sample) => ({ type: DRAG_SAMPLE , payload: sample});
export const dragEffect = (effectNumber) => ({ type: DRAG_EFFECT , payload: effectNumber});
export const dragPattern = (patternNumber) => ({ type: DRAG_PATTERN, payload: patternNumber});

export const mouseDown = (m) => ({ type: MOUSE_DOWN, payload: m});
export const dragToggle = (toggle) => ({ type: DRAG_TOGGLE, payload: toggle});
export const dragStepTranspose = (transpose) => ({ type: DRAG_STEP_TRANSPOSE, payload: transpose});
export const setCommandDown = (c) => ({ type: COMMAND_DOWN, payload: c});

export const trackRecording = (t, r) => ({ type: TRACK_RECORDING, payload: {id: t, recording: r}});
export const trackPreparingToRecord = (t, r) => ({ type: TRACK_PREPARING_TO_RECORD, payload: {trackNumber: t, preparing: r}});

export const setAllTrackSteps = (t, steps, pianoSteps, fills, stepToId, stepToPosition, pianoRollDurations, patternSteps, groups) => (
    {
        type: SET_ALL_TRACK_STEPS,
        payload: {
            id: t,
            steps: steps,
            pianoRollSteps: pianoSteps,
            fills: fills,
            stepToId: stepToId,
            stepToPosition: stepToPosition,
            pianoRollDurations: pianoRollDurations,
            patternSteps: patternSteps,
            groups
        }});

export const setTrackSteps = (t, s) => ({ type: SET_TRACK_STEPS, payload: {id: t, steps: s}});
export const setTrackFills = (t, s) => ({ type: SET_TRACK_FILLS, payload: {id: t, fills: s}});
export const setTrackPianoRollSteps = (t, s) => ({ type: SET_TRACK_PIANO_ROLL_STEPS, payload: {id: t, steps: s}});

export const setSelectedTrack = (track) => ({ type: SET_SELECTED_TRACK, payload: track});
export const setSelectedStep = (step) => ({ type: SET_SELECTED_STEP, payload: step});
export const setHoveredStep = (step) => ({ type: SET_HOVERED_STEP, payload: step});
export const setSelectedGroup = (group) => ({ type: SET_SELECTED_GROUP, payload: group});


export const setTrackVolume = (trackNumber, volume) => ({ type: SET_TRACK_VOLUME, payload:
                                                          {id: trackNumber, volume: volume }});
export const setTrackMuted = (id, muted) => ({ type: SET_TRACK_MUTED, payload: {
    id: id, muted: muted}});

export const setTrackSolo = (id, solo) => ({ type: SET_TRACK_SOLO, payload: {
    id, solo: solo}});

export const setGroupVolume = (groupNumber, volume) => ({ type: SET_GROUP_VOLUME, payload:
                                                          {groupNumber: groupNumber, volume: volume }});
export const setGroupMuted = (groupNumber, muted) => ({ type: SET_GROUP_MUTED, payload: {
    groupNumber: groupNumber, muted: muted}});

export const setQuantized = (quantized) => ({ type: SET_QUANTIZED, payload: quantized});
export const setIsRecording = (isRecording) => ({ type: SET_IS_RECORDING, payload: isRecording});
export const setIsRecordingExpanded = (isRecordingExpanded) => ({ type: SET_IS_RECORDING_EXPANDED, payload: isRecordingExpanded});
export const setIsRecordingMix = (isRecordingMix) => ({ type: SET_IS_RECORDING_MIX, payload: isRecordingMix});
export const setIsPlaying =
    (sequenceId, isPlaying) =>
    ({
        type: SET_IS_PLAYING,
        payload: {
            sequenceId: sequenceId,
            isPlaying: isPlaying
        }});
export const setIsPlayingMix = (isPlayingMix) => ({ type: SET_IS_PLAYING_MIX, payload: isPlayingMix});

export const setSendMuted = (sendNumber, muted) => ({ type: SET_SEND_MUTED, payload: {
    sendNumber: sendNumber, muted: muted}});

export const setStepDragging = (step) => ({ type: SET_STEP_DRAGGING, payload: step});
export const setStepToCopy = (step) => ({ type: SET_STEP_TO_COPY, payload: step});

export const setSequenceName = (name) => ({ type: SET_SEQUENCE_NAME, payload: name});

export const setSelectedEffect = (effectNumber) => ({ type: SET_SELECTED_EFFECT, payload: effectNumber});

export const setEffectParameterValue = (id, value) => ({ type: SET_EFFECT_PARAMETER_VALUE, payload: {id: id, value: value}});

export const setEffectsPaneOption = (option) => ({ type: SET_EFFECTS_PANE_OPTION, payload: option});

export const setSelectedParameter = (parameter) => ({ type: SET_SELECTED_PARAMETER, payload: parameter});
export const setSelectedParameterFlashing = (parameter) => ({ type: SET_SELECTED_PARAMETER_FLASHING, payload: parameter});

export const setMixes = (mixes) => ({ type: SET_MIXES, payload: mixes});
export const setCurrentMix = (mix) => ({ type: SET_CURRENT_MIX, payload: mix});

export const setErasingAutomation = (mix) => ({ type: SET_ERASING_AUTOMATION, payload: mix});

export const setTrackSendVolume = (subSequenceId, trackNumber, sendNumber, volume) => (
    { type: SET_TRACK_SEND_VOLUME,
      payload: {
          subSequenceId: subSequenceId,
          trackNumber: trackNumber,
          sendNumber: sendNumber,
          volume: volume
      }});

export const setTrackFocused = (track) => ({ type: SET_TRACK_FOCUSED, payload: track});

export const setYearSelected = (year) => ({ type: SET_YEAR_SELECTED, payload: year});
export const setCountriesSelected = (countries) => ({ type: SET_COUNTRIES_SELECTED, payload: countries});
export const setVideosSelected = (videos) => ({ type: SET_VIDEOS_SELECTED, payload: videos});
export const setStylesSelected = (styles) => ({ type: SET_STYLES_SELECTED, payload: styles});
export const setTagsSelected = (tags) => ({ type: SET_TAGS_SELECTED, payload: tags});
export const setChordSelected = (chord) => ({ type: SET_CHORD_SELECTED, payload: chord});
export const setHierarchyRoot = (root) => ({ type: SET_HIERARCHY_ROOT, payload: root});
export const setHierarchyTree = (tree) => ({ type: SET_HIERARCHY_TREE, payload: tree});

export const setShowYearSlider = (show) => ({ type: SET_SHOW_YEAR_SLIDER, payload: show});
export const setShowCountries = (show) => ({ type: SET_SHOW_COUNTRIES, payload: show});
export const setShowVideos  = (show) => ({ type: SET_SHOW_VIDEOS, payload: show});
export const setShowStyles = (show) => ({ type: SET_SHOW_STYLES, payload: show});
export const setShowTags = (show) => ({ type: SET_SHOW_TAGS, payload: show});
export const setShowChordFilter = (show) => ({ type: SET_SHOW_CHORD_FILTER, payload: show});

export const setIsDraggingDuration = (duration) => ({ type: SET_IS_DRAGGING_DURATION, payload: duration});
export const setStepDataDragging = (stepData) => ({ type: SET_STEP_DATA_DRAGGING, payload: stepData});
export const setPianoRollSelection =
    (stepNumber, transpose, numSteps, numNotes) =>
    ({
        type: SET_PIANO_ROLL_SELECTION,
        payload: {
            stepNumber: stepNumber,
            transpose: transpose,
            numSteps: numSteps,
            numNotes: numNotes,
        }});


export const setSelectedPianoRollSteps =
    (selectedSteps) =>
    ({
        type: SET_SELECTED_PIANO_ROLL_STEPS,
        payload: selectedSteps
    });

export const setSearchResultsSamples =
    (sampleHashes) =>
    ({
        type: SET_SEARCH_RESULTS_SAMPLES,
        payload: sampleHashes
    });

export const setSelectedChordSample =
    (obj =>
    ({
        type: SET_SELECTED_CHORD_SAMPLE,
        payload: obj
    }));

export const setStepsToCopy =
    (steps =>
    ({
        type: SET_STEPS_TO_COPY,
        payload: steps
    }));

export const setLoadingSequence = (id, loading) => ({ type: SET_LOADING_SEQUENCE, payload: {id: id, loading: loading}});

export const setEasyPatternToCopy = (easyPattern) => ({ type: SET_EASY_PATTERN_TO_COPY, payload: easyPattern});

export const setSampleAuditioning = (sampleId) => ({ type: SET_SAMPLE_AUDITIONING, payload: sampleId});

export const setLastMidiKeyMapped = (midiKey) => ({ type: SET_LAST_MIDI_KEY_MAPPED, payload: midiKey});
export const setTrackIsEnabled = (subSequenceId, trackNumber, isEnabled) => (
    {
        type: SET_TRACK_IS_ENABLED,
        payload: {
            subSequenceId: subSequenceId,
            trackNumber: trackNumber,
            isEnabled: isEnabled
        }
    });

export const setSelectedSampleTag = (sampleId, tag) => ({ type: SET_SELECTED_SAMPLE_TAG, payload: {sampleId: sampleId, tag: tag}});

export const setTransposeDragging = (dragging) => ({ type: SET_TRANSPOSE_DRAGGING, payload: {transpose: dragging}});

export const setMasterVolume =
    (sequenceId, volume) => (
        { type: SET_MASTER_VOLUME,
          payload: {
              sequenceId: sequenceId,
              volume: volume
          }
        });

export const setUserViewMode = (userViewMode) => ({ type: SET_USER_VIEW_MODE, payload: userViewMode});
export const setCurrentUserMix = (mix) => ({ type: SET_CURRENT_USER_MIX, payload: mix});
export const setUserHasEditsToSave = (hasEdits) => ({ type: SET_USER_HAS_EDITS_TO_SAVE, payload: hasEdits});

export const setPatternToEditColor = (pattern) => ({ type: SET_PATTERN_TO_EDIT_COLOR, payload: pattern});
export const setPatternColor = (pattern, color) => (
    { type: SET_PATTERN_COLOR,
      payload: {
          pattern: pattern,
          color: color}});

export const setCompactMode = (isCompact) => ({ type: SET_COMPACT_MODE, payload: isCompact});

export const setShowLFOs = (show) => ({ type: SET_SHOW_LFOS, payload: show});
export const setShowEnvelopes = (show) => ({ type: SET_SHOW_ENVELOPES, payload: show});

export const setTracksToResample = (tracks) => ({ type: SET_TRACKS_TO_RESAMPLE, payload: tracks});

export const setProjectAutomationMode  = (mode) => ({ type: SET_PROJECT_AUTOMATION_MODE, payload: mode});

export const newSequence = () => ({ type: NEW_SEQUENCE, payload: {}});

export const setStepsSelection = (trackNumber, stepFrom, stepTo) =>
    ({
        type: SET_STEPS_SELECTION ,
        payload: {
            trackNumber: trackNumber,
            fromStep: stepFrom,
            toStep: stepTo
        }
    });
export const setSelectedSteps = (trackNumber, patternNumber, steps) => ({ type: SET_SELECTED_STEPS, payload: {trackNumber: trackNumber, patternNumber: patternNumber, steps: steps}});
export const setStepNumberDraggingFrom = (stepNumber) => ({ type: SET_STEP_NUMBER_DRAGGING_FROM, payload: stepNumber});

export const setSequencePatternLocks = (patternLocks) => (
    { type: SET_SEQUENCE_PATTERN_LOCKS,
      payload: {
          patternLocks: patternLocks,
      }});

export const setSequencePatternLocked = (patternNumber, locked) => (
    {
        type: SET_SEQUENCE_PATTERN_LOCKED,
        payload: {
            patternNumber: patternNumber,
            locked: locked
        }});

export const setTrackPatternLocked = (subSequence, trackNumber, patternNumber, locked) => (
    {
        type: SET_TRACK_PATTERN_LOCKED,
        payload: {
            subSequence: subSequence,
            trackNumber: trackNumber,
            patternNumber: patternNumber,
            locked: locked
        }});

export const setTrackPatternLocks = (subSequence, trackNumber, patternLocks) => (
    { type: SET_TRACK_PATTERN_LOCKS,
      payload: {
          subSequence: subSequence,
          trackNumber: trackNumber,
          patternLocks: patternLocks,
      }});

export const setEffectPatternLocks = (effectId, patternLocks) => (
    { type: SET_EFFECT_PATTERN_LOCKS,
      payload: {
          id: effectId,
          patternLocks: patternLocks
      }});

export const updateStepsForAllTracks = (updateData) => ({ type: UPDATE_STEPS_FOR_ALL_TRACKS, payload: updateData});

export const setLFOPatternLocks = (subSequence, patternLocks) =>
    ({
        type: SET_LFO_PATTERN_LOCKS,
        payload: {
            patternLocks: patternLocks,
            subSequence: subSequence,}
    });

export const setEnvelopePatternLocks = (subSequence, patternLocks) =>
    ({
        type: SET_ENVELOPE_PATTERN_LOCKS,
        payload: {
            patternLocks: patternLocks,
            subSequence: subSequence
        }
    });

export const setPianoRollPagination = (start, end) => ({ type: SET_PIANO_ROLL_PAGINATION, payload: {start : start, end: end}});

export const setIsResampling = (isResampling) => ({ type: SET_IS_RESAMPLING, payload: isResampling});
export const setResampleDuration = (resampleDuration) => ({ type: SET_RESAMPLE_DURATION, payload: resampleDuration});

export const setKeyMappings = (keyMappings) => ({ type: SET_KEY_MAPPINGS, payload: keyMappings});
export const setPadMappings = (padMappings) => ({ type: SET_PAD_MAPPINGS, payload: padMappings});

export const setShowSequenceModal = (show) => ({ type: SET_SHOW_SEQUENCE_MODAL, payload: show});

export const setShowModsModal = (show) => ({ type: SET_SHOW_MODS_MODAL, payload: show});

export const setMultiParameterSliderValue = (id, value) => (
    {
        type: SET_MULTI_PARAMETER_SLIDER,
        payload: {
            id: id,
            value: value
        }
    });

export const setSequenceRolling = (rolling) => ({ type: SET_SEQUENCE_ROLLING, payload: rolling});

export const setTrackEffectsChain = (trackNumber, effectsChain) => (
    {
        type: SET_TRACK_EFFECTS_CHAIN,
        payload: {
            trackNumber: trackNumber,
            effectsChain: effectsChain
        }
    });

export const setShowSequences = (show) => ({ type: SET_SHOW_SEQUENCES, payload: show});
export const setShowPresets = (show) => ({ type: SET_SHOW_PRESETS, payload: show});
export const setShowInstruments = (show) => ({ type: SET_SHOW_INSTRUMENTS, payload: show});

export const setTrackRolling = (rolling) => ({ type: SET_TRACK_ROLLING, payload: rolling});

export const setZIndexHack = (hack) => ({ type: SET_Z_INDEX_HACK, payload: hack});

export const setLoadedTracks = (tracks) => ({ type: SET_LOADED_TRACKS, payload: tracks});

export const setBPM = (bpm) => ({ type: SET_BPM, payload: bpm});

export const setResampleMaster = (flag) => ({ type: SET_RESAMPLE_MASTER, payload: flag});

export const setYoutubeSearchTerms = (s) => ({ type: SET_YOUTUBE_SEARCH_TERMS, payload: s});

export const setAudioInputSource = (s) => ({ type: SET_AUDIO_INPUT_SOURCE, payload: s});

export const setWaveformSelection = (x) => (
    {
        type: SET_WAVEFORM_SELECTION,
        payload: x
    });

export const setWaveformSelectionEnd = (x) => (
    {
        type: SET_WAVEFORM_SELECTION_END,
        payload: x
    });

export const setMidiMapMode= (mode) => (
    {
        type: SET_MIDI_MAP_MODE,
        payload: mode
    });

export const setParameterMidiMapSelection= (parameter) => (
    {
        type: SET_PARAMETER_MIDI_MAP_SELECTION,
        payload: parameter
    });

export const setParameterMidiMapping= (parameter, midiControl) => (
    {
        type: SET_PARAMETER_MIDI_MAPPING,
        payload: {
            parameter: parameter,
            midiControl: midiControl
        }
    });

export const deleteParameterMidiMapping = (parameter) => (
    {
        type: DELETE_PARAMETER_MIDI_MAPPING,
        payload: parameter,
    });

export const setActionMidiMapSelection= (action) => (
    {
        type: SET_ACTION_MIDI_MAP_SELECTION,
        payload: action
    });

export const setActionMidiMapping= (action, midiControl) => (
    {
        type: SET_ACTION_MIDI_MAPPING,
        payload: {
            action: action,
            midiControl: midiControl
        }
    });

export const deleteMidiMappings = (control) => (
    {
        type: DELETE_MIDI_MAPPINGS,
        payload: control,
    });


export const setLatency = (latency) => (
    {
        type: SET_LATENCY,
        payload: latency,
    });

export const setSpotlightTracks = (tracks) => (
    {
        type: SET_SPOTLIGHT_TRACKS,
        payload: tracks,
    });

export const setClockType = (type) => (
    {
        type: SET_CLOCK_TYPE,
        payload: type,
    });

export const setConnectionStatus = (status) => (
    {
        type: SET_CONNECTION_STATUS,
        payload: status,
    });

export const setConnectedUserName = (userName) => (
    {
        type: SET_CONNECTED_USER_NAME,
        payload: userName,
    });

export const setClockTick = (step) => (
    {
        type: SET_CLOCK_TICK,
        payload: step,
    });

export const setPlayScheduled = (flag) => (
    {
        type: SET_PLAY_SCHEDULED,
        payload: flag,
    });

export const setAvailableUsersToSync = (users) => (
    {
        type: SET_AVAILABLE_USERS_TO_SYNC,
        payload: users,
    });

export const setSearchSortBy = (sortBy) => (
    {
        type: SET_SEARCH_SORT_BY,
        payload: sortBy,
    });

export const setMidiEffectDragging = (effect) => (
    {
        type: SET_MIDI_EFFECT_DRAGGING,
        payload: effect,
    });

export const setShowTrackEffects = (trackNumber, show) => (
    {
        type: SET_SHOW_TRACK_EFFECTS,
        payload: {
            trackNumber: trackNumber,
            show: show
        },
    });

export const setShowConvolverModal = (show, sample) => (
    {
        type: SET_SHOW_CONVOLVER_MODAL,
        payload: {
            show: show,
            convolverSample: sample
        },
    });

export const setShowPasswordModal = (show) => (
    {
        type: SET_SHOW_PASSWORD_MODAL,
        payload: show
    });

export const setPasswordModalCallback = (callback) => (
    {
        type: SET_PASSWORD_MODAL_CALLBACK,
        payload: callback
    });

export const setShowShareSequenceModal = (show) => (
    {
        type: SET_SHOW_SHARE_SEQUENCE_MODAL,
        payload: show
    });

export const hideAllEffects = () => (
    {
        type: HIDE_ALL_EFFECTS,
        payload: {},
    });

export const setEffectCollapsed = (id, isCollapsed) => (
    {
        type: SET_EFFECT_COLLAPSED,
        payload: {
            id: id,
            isCollapsed: isCollapsed
        },
    });

export const setContextualHelp = (element, arg) => (
    {
        type: SET_CONTEXTUAL_HELP,
        payload: {element, arg}
    });

export const setSelectedLFO = (lfo) => (
    {
        type: SET_SELECTED_LFO,
        payload: lfo,
    });

export const setSelectedEnvelope = (envelope) => (
    {
        type: SET_SELECTED_ENVELOPE,
        payload: envelope
    });

export const setSidebarCollapsed = (collapsed) => (
    {
        type: SET_SIDEBAR_COLLAPSED,
        payload: collapsed
    });

export const setMixEvents = (subSequenceId, type, events) => (
    {
        type: SET_MIX_EVENTS,
        payload: {
            subSequenceId: subSequenceId,
            type: type,
            events: events
        }
    });

export const setShowGroups = (showGroups) => (
    {
        type: SET_SHOW_GROUPS,
        payload: showGroups
    });

export const setCurrentSubSequence = (sequenceId, subSequenceId) => (
    {
        type: SET_CURRENT_SUB_SEQUENCE,
        payload: {
            sequenceId: sequenceId,
            subSequenceId: subSequenceId,
        }
    });


export const setSubSequences = (id, ids) => (
    {
        type: SET_SUB_SEQUENCES,
        payload: {
            sequenceId: id,
            ids: ids,
        },
    });

export const setAllTrackPatternLocks = (locks) => (
    {
        type: SET_ALL_TRACK_PATTERN_LOCKS,
        payload: locks
    });

export const setAllLFOLocks = (locks) => (
    {
        type: SET_ALL_LFO_LOCKS,
        payload: locks,
    });

export const setAllEnvelopeLocks= (locks) => (
    {
        type: SET_ALL_ENVELOPE_LOCKS,
        payload: locks
    });

export const setMixViewMode = (mode) => (
    {
        type: SET_MIX_VIEW_MODE,
        payload: mode
    });

export const setSubSequenceFade = (id, value) => (
    {
        type: SET_SUB_SEQUENCE_FADE,
        payload: {
            subSequenceId: id,
            value: value,
        },
    });

export const setSampleSlices= (id, slices) => (
    {
        type: SET_SAMPLE_SLICES,
        payload: {
            id: id,
            slices: slices,
        },
    });

export const setSelectedArrangementEvents  = (events) => (
    {
        type: SET_SELECTED_ARRANGEMENT_EVENTS,
        payload: events,
    });

export const setShowDateSampled = (show) => (
    {
        type: SET_SHOW_DATE_SAMPLED,
        payload: show
    });

export const setDateSampled = (dates) => (
    {
        type: SET_DATE_SAMPLED,
        payload: dates
    });

export const setEffectParameterValues = (values) => (
    {
        type: SET_EFFECT_PARAMETER_VALUES,
        payload: values
    });

export const setTrackPanning = (trackNumber, pan) => (
    {
        type: SET_TRACK_PANNING,
        payload: {
            trackNumber: trackNumber,
            pan: pan
        }
    });

export const setGroupPanning = (groupNumber, pan) => (
    {
        type: SET_GROUP_PANNING,
        payload: {
            groupNumber: groupNumber,
            pan: pan
        }
    });

export const setSelectedRecord = (record) => (
    {
        type: SET_SELECTED_RECORD,
        payload: record,
    });

export const set2DSelection = (startX, startY, endX, endY) => (
    {
        type: SET_2D_SELECTION,
        payload: {
            startX: startX,
            startY: startY,
            endX: endX,
            endY: endY
        },
    });

export const setSimilarSoundsToFind = (sampleId) => (
    {
        type: SET_SIMILAR_SOUNDS_TO_FIND,
        payload: sampleId,
    });

export const setShowSamples2D = (show) => (
    {
        type: SET_SHOW_SAMPLES_2D,
        payload: show,
    });

export const setLastNotePlayed = (lastNote) => (
    {
        type: SET_LAST_NOTE_PLAYED,
        payload: lastNote,
    });

export const setSidebarViewMode = (mode) => (
    {
        type: SET_SIDEBAR_VIEW_MODE,
        payload: mode,
    });

export const setDiscogsSelected = (selected) => (
    {
        type: SET_DISCOGS_SELECTED,
        payload: selected,
    });

export const setSelectedFolder = (selected) => (
    {
        type: SET_SELECTED_FOLDER,
        payload: selected,
    });

export const setSelectedPreset = (selected) => (
    {
        type: SET_SELECTED_PRESET,
        payload: selected,
    });

export const setHasChangesToFolders = (flag) => (
    {
        type: SET_HAS_CHANGES_TO_FOLDERS,
        payload: flag,
    });

export const setCursorTrack = (track) => (
    {
        type: SET_CURSOR_TRACK,
        payload: track,
    });

export const setCursorStep = (step) => (
    {
        type: SET_CURSOR_STEP,
        payload: step,
    });

export const setCursorShow = (show) => (
    {
        type: SET_CURSOR_SHOW,
        payload: show,
    });

export const setFolderDragging = (folder) => (
    {
        type: SET_FOLDER_DRAGGING,
        payload: folder,
    });

export const setPresetDragging = (preset) => (
    {
        type: SET_PRESET_DRAGGING,
        payload: preset,
    });

export const setSampleDragging = (sample) => (
    {
        type: SET_SAMPLE_DRAGGING,
        payload: sample,
    });

export const setEffectsChainToShow = (subSequenceId, track, chainNumber) => (
    {
        type: SET_EFFECTS_CHAIN_TO_SHOW,
        payload: {
            subSequenceId: subSequenceId,
            trackNumber: track,
            chainNumber: chainNumber
        },
    });

export const setSubSequenceMuted = (id, muted) => (
    {
        type: SET_SUB_SEQUENCE_MUTED,
        payload: {
            id: id,
            muted: muted,
        },
    });

export const setTrackFrozen = (subSequenceId, trackNumber, frozen) => (
    {
        type: SET_TRACK_FROZEN,
        payload: {
            subSequenceId: subSequenceId,
            trackNumber: trackNumber,
            frozen: frozen,
        },
    });

export const setTrackToFreeze = (subSequenceId, trackNumber) => (
    {
        type: SET_TRACK_TO_FREEZE,
        payload: {
            subSequenceId: subSequenceId,
            trackNumber: trackNumber,
        },
    });

export const setFrozenTrackPlaying = (subSequenceId, trackNumber, playing) => (
    {
        type: SET_FROZEN_TRACK_PLAYING,
        payload: {
            subSequenceId: subSequenceId,
            trackNumber: trackNumber,
            playing: playing,
        },
    });

export const setFrozenTracksPlaying = (subSequenceId, frozenTracksPlaying) => (
    {
        type: SET_FROZEN_TRACKS_PLAYING,
        payload: {
            subSequenceId: subSequenceId,
            frozenTracksPlaying: frozenTracksPlaying,
        },
    });

export const setFrozenTracks = (subSequenceId, frozenTracks) => (
    {
        type: SET_FROZEN_TRACKS,
        payload: {
            subSequenceId: subSequenceId,
            frozenTracks: frozenTracks,
        },
    });

export const setEffectsChainsToShow = (subSequenceId, effectsChains) => (
    {
        type: SET_EFFECTS_CHAINS_TO_SHOW,
        payload: {
            subSequenceId: subSequenceId,
            effectsChains: effectsChains,
        },
    });

export const setSelectedOnsets = (id, selectedOnsets) => (
    {
        type: SET_SELECTED_ONSETS,
        payload: {
            id: id,
            selectedOnsets: selectedOnsets,
        },
    });

export const setSingleStepToDrag = (stepData) => (
    {
        type: SET_SINGLE_STEP_TO_DRAG,
        payload: stepData
    });

export const setStepNumberDraggedTo = (stepNumber) => (
    {
        type: SET_STEP_NUMBER_DRAGGED_TO,
        payload: stepNumber
    });

export const setSearchResultsStart = (start) => (
    {
        type: SET_SEARCH_RESULTS_START,
        payload: start
    });

export const setShowStepOptions = (option, effect) => (
    {
        type: SET_SHOW_STEP_OPTIONS,
        payload: {
            option: option,
            effect: effect,
        }
    });

export const setMasterStepToggles = (steps) => (
    {
        type: SET_MASTER_STEP_TOGGLES,
        payload:  steps
    });

export const setParametersToRecord = (params) => (
    {
        type: SET_PARAMETERS_TO_RECORD,
        payload:  params
    });

export const setOnsetThreshold = (threshold) => (
    {
        type: SET_ONSET_THRESHOLD,
        payload: threshold
    });

export const setShowOnsets = (show) => (
    {
        type: SET_SHOW_ONSETS,
        payload: show
    });

export const setSelectedGuild = (guild) => (
    {
        type: SET_SELECTED_GUILD,
        payload: guild
    });

export const setPianoRollDragOffset = (offset) => (
    {
        type: SET_PIANO_ROLL_DRAG_OFFSET,
        payload: offset
    });

export const setPianoRollNotes = (notes) => (
    {
        type: SET_PIANO_ROLL_NOTES,
        payload: notes
    });

export const setStepAndDataDragging = (stepNumber, stepData) => (
    {
        type: SET_STEP_AND_DATA_DRAGGING,
        payload: {
            stepNumber: stepNumber,
            stepData: stepData
        }
    });

export const setShowLogin= (show) => (
    {
        type: SET_SHOW_LOGIN,
        payload: show
    });

export const setSigningUp = (signingUp) => (
    {
        type: SET_SIGNING_UP,
        payload: signingUp
    });

export const setUserToken = (userName, token) => (
    {
        type: SET_USER_TOKEN,
        payload: {
            userName,
            token
        }
    });

export const setPendingTransactions = (pendingTransactions) => (
    {
        type: SET_PENDING_TRANSACTIONS,
        payload: pendingTransactions
    });

export const setCommandInput = (input) => (
    {
        type: SET_COMMAND_INPUT,
        payload: input
    });

export const setCommandPrefix = (prefix) => (
    {
        type: SET_COMMAND_PREFIX,
        payload: prefix
    });

export const setViMode = (mode) => (
    {
        type: SET_VI_MODE,
        payload: mode
    });

export const setTrackWarp = (subSequenceId, trackNumber, warp) => (
    {
        type: SET_TRACK_WARP,
        payload: {
            subSequenceId,
            trackNumber,
            warp,
        }
    });

export const setSubSequenceWarps = (subSequenceId, warps) => (
    {
        type: SET_SUB_SEQUENCE_WARPS,
        payload: {
            subSequenceId,
            warps,
        }
    });

export const setArrangementSelection = (start, end) => (
    {
        type: SET_ARRANGEMENT_SELECTION,
        payload: {
            start: start,
            end: end,
        }
    });

export const setArrangementMouseX= (mouseX) => (
    {
        type: SET_ARRANGEMENT_MOUSE_X,
        payload: mouseX
    });

export const setArrangementAutomationToShow = (subSequenceId, type) => (
    {
        type: SET_ARRANGEMENT_AUTOMATION_TO_SHOW,
        payload: {
            subSequenceId,
            type
        }
    });

export const setArrangementLooping = (looping) => (
    {
        type: SET_ARRANGEMENT_LOOPING,
        payload: looping
    });

export const setArrangementSelectedRows = (rows) => (
    {
        type: SET_ARRANGEMENT_SELECTED_ROWS,
        payload: rows
    });

export const setArrangementLoopSelected = (selected) => (
    {
        type: SET_ARRANGEMENT_LOOP_SELECTED,
        payload: selected
    });

export const setArrangementRowSelections = (selections) => (
    {
        type: SET_ARRANGEMENT_ROW_SELECTIONS,
        payload: selections
    });

export const setArrangementZoom = (zoom) => (
    {
        type: SET_ARRANGEMENT_ZOOM,
        payload: zoom
    });

export const setSelectedSequence = (id) => (
    {
        type: SET_SELECTED_SEQUENCE,
        payload: id
    });

export const setExploreMixerEffect = (effect, toggle) => (
    {
        type: SET_EXPLORE_MIXER_EFFECT,
        payload: {
            effect,
            toggle
        }
    });

export const setExploreEQEffect = (type, toggle) => (
    {
        type: SET_EXPLORE_EQ_EFFECT,
        payload: {
            type,
            toggle
        }
    });

export const setSelectedSendEffect = (effect) => (
    {
        type: SET_SELECTED_SEND_EFFECT,
        payload: effect
    });

export const setInstrumentTypeDragging = (type) => (
    {
        type: SET_INSTRUMENT_TYPE_DRAGGING,
        payload: type
    });

export const setTrackIsLoading = (subSequenceId, trackNumber, isLoading) => (
    {
        type: SET_TRACK_IS_LOADING,
        payload: {
            subSequenceId,
            trackNumber,
            isLoading
        }
    });

export const setPianoRollCursor = (cursor) => (
    {
        type: SET_PIANO_ROLL_CURSOR,
        payload: cursor
    });

export const setArrangementXScale = (xScale) => (
    {
        type: SET_ARRANGEMENT_X_SCALE,
        payload: xScale
    });

export const setTotalArrangementLength = (len) => (
    {
        type: SET_TOTAL_ARRANGEMENT_LENGTH,
        payload: len
    });

export const setArrangementBottomHeight = (height) => (
    {
        type: SET_ARRANGEMENT_BOTTOM_HEIGHT,
        payload: height
    });

export const setArrangementBottomMode = (mode) => (
    {
        type: SET_ARRANGEMENT_BOTTOM_MODE,
        payload: mode
    });

export const setArrangementBottomResizing = (isResizing) => (
    {
        type: SET_ARRANGEMENT_BOTTOM_RESIZING,
        payload: isResizing,
    });

export const setArrangementPatternDragging = (patternDragging, offsetX) => (
    {
        type: SET_ARRANGEMENT_PATTERN_DRAGGING,
        payload: patternDragging === undefined ? undefined :
            {
                patternDragging,
                offsetX
            }
    });

export const setArrangementPatternStartStep = (subSequenceId, patternId, startStep) => (
    {
        type: SET_ARRANGEMENT_PATTERN_START_STEP,
        payload:  {
            subSequenceId,
            patternId,
            startStep
        }
    });

export const setArrangementCursorStep = (step) => (
    {
        type: SET_ARRANGEMENT_CURSOR_STEP,
        payload: step
    });

export const setArrangementPatternResizing = (pattern, direction) => (
    {
        type: SET_ARRANGEMENT_PATTERN_RESIZING,
        payload: pattern === undefined ? undefined :
            {
                pattern,
                direction
            }
    });

export const setArrangementBrowserMode = (mode) => (
    {
        type: SET_ARRANGEMENT_BROWSER_MODE,
        payload: mode
    });

export const setSampleToExplore = (sampleToExplore) => (
    {
        type: SET_SAMPLE_TO_EXPLORE,
        payload: sampleToExplore
    });

export const setEffectRackNodePosition = (rackId, effectId, x, y) => (
    {
        type: SET_EFFECT_RACK_NODE_POSITION,
        payload: {
            rackId,
            effectId,
            x,
            y
        },
    });

export const setAnnotationDragging = (dragging) => (
    {
        type: SET_ANNOTATION_DRAGGING,
        payload: dragging
    });

export const setTrackAutomationDevice = (trackId, device) => (
    {
        type: SET_TRACK_AUTOMATION_DEVICE,
        payload: {
            trackId,
            device
        }
    });

export const setTrackAutomationRackDevice = (trackId, device) => (
    {
        type: SET_TRACK_AUTOMATION_RACK_DEVICE,
        payload: {
            trackId,
            device
        }
    });

export const setTrackAutomationSubDevice = (trackId, subDevice) => (
    {
        type: SET_TRACK_AUTOMATION_SUB_DEVICE,
        payload: {
            trackId,
            subDevice 
        }
    });

export const setTrackAutomationParameter = (trackId, parameter) => (
    {
        type: SET_TRACK_AUTOMATION_PARAMETER,
        payload: {
            trackId,
            parameter
        }
    });

export const setShowAutomation = (show) => (
    {
        type: SET_SHOW_AUTOMATION,
        payload: {
            show,
        }
    });

export const setParameterAutomations = (parameter, automations, scheduler) => (
    {
        type: SET_PARAMETER_AUTOMATIONS,
        payload: {
            parameter,
            automations,
            scheduler
        }
    });

export const setActionsRemaining = (actionsRemaining) => (
    {
        type: SET_ACTIONS_REMAINING,
        payload: actionsRemaining
    });

export const setTimeRemaining = (timeRemaining) => (
    {
        type: SET_TIME_REMAINING,
        payload: timeRemaining
    });

export const setShowPianoRoll = (showPianoRoll) => (
    {
        type: SET_SHOW_PIANO_ROLL,
        payload: showPianoRoll
    });

export const setSelectedRackSubTrack  = (trackId, track) => (
    {
        type: SET_SELECTED_RACK_SUB_TRACK,
        payload: {
            trackId,
            track
        }
    });

export const deleteAutomationsForParameters = (parameters) => (
    {
        type: DELETE_AUTOMATIONS_FOR_PARAMETERS,
        payload: parameters
    });

export const deleteAutomationsForEngine = (engineId) => (
    {
        type: DELETE_AUTOMATIONS_FOR_ENGINE,
        payload: engineId
    });

export const setAutomationGuidePoint = (id, guidePoint) => (
    {
        type: SET_AUTOMATION_GUIDE_POINT,
        payload: {id, guidePoint}
    });

export const setAutomationPointDragging  = (id, point) => (
    {
        type: SET_AUTOMATION_POINT_DRAGGING,
        payload: {id, point},
    });

export const setAutomationPointHasMoved  = (id, hasMoved) => (
    {
        type: SET_AUTOMATION_POINT_HAS_MOVED,
        payload: {id, hasMoved},
    });

export const setAutomationPointHovered  = (id, pt) => (
    {
        type: SET_AUTOMATION_POINT_HOVERED,
        payload: {id, pt}
    });

export const setTrackToConvert = (track) => ({
        type: SET_TRACK_TO_CONVERT,
        payload: track
    });

export const setAutomationSelection = (id, selection) => ({
    type: SET_AUTOMATION_SELECTION,
    payload: {id, selection}
});

export const setAutomationPointsSelected = (id, points) => ({
    type: SET_AUTOMATION_POINTS_SELECTED,
    payload: {id, points}
});

export const setExplorePersonSelected = (person) => ({
        type: SET_EXPLORE_PERSON_SELECTED,
        payload: person
    });

export const setExploreAllSequences = (sequences) => ({
        type: SET_EXPLORE_ALL_SEQUENCES,
        payload: sequences
    });

export const setRecordingExploreMix = (isRecording) => ({
        type: SET_RECORDING_EXPLORE_MIX,
        payload: isRecording
    });

export const setWorksLoaded = (worksLoaded) => ({
    type: SET_WORKS_LOADED,
    payload: worksLoaded
});

export const setWorkTranspose = (sequenceId, transpose) => ({
    type: SET_WORK_TRANSPOSE,
    payload: {
        sequenceId,
        transpose
    }
});

export const setWorkVolume = (sequenceId, volume) => ({
    type: SET_WORK_VOLUME,
    payload: {
        sequenceId,
        volume
    }
});

export const setExploreMixLoaded = (mix) => ({
    type: SET_EXPLORE_MIX_LOADED,
    payload: mix
});

export const setIsMacroMapping = (isMapping) => ({
    type: SET_IS_MACRO_MAPPING,
    payload: isMapping
});

export const setParameterToMap = (parameter) => ({
    type: SET_PARAMETER_TO_MAP,
    payload: parameter
});

export const setMixColorValue = (id, value) => ({
    type: SET_MIX_COLOR_VALUE,
    payload: {id, value}
});

export const setMixHasEdits = (hasEdits) => ({
    type: SET_MIX_HAS_EDITS,
    payload: hasEdits
});

export const setScriptVariables = (id, variables) => ({
    type: SET_SCRIPT_VARIABLES,
    payload: {
        id, variables
    }
});

export const setExploreOption = (opt) => ({
    type: SET_EXPLORE_OPTION,
    payload: opt
});

export const setAnnotationsView = (work) => ({
    type: SET_ANNOTATIONS_VIEW,
    payload: work
});

export const setExploreToast = (toast) => ({
    type: SET_EXPLORE_TOAST,
    payload: toast
});

export const setParameterSliderDown = (param) => ({
    type: SET_PARAMETER_SLIDER_DOWN,
    payload: param
});

export const moveEngineAutomations = (oldId, newId) => ({
    type: MOVE_ENGINE_AUTOMATIONS,
    payload: {oldId, newId}
});

export const setSequenceLoadingProgress = (sequenceId, progress) => ({
    type: SET_SEQUENCE_LOADING_PROGRESS,
    payload: {sequenceId, progress}
});

export const setTrackBrowsedSamples = (trackId, samples) => ({
    type: SET_TRACK_BROWSED_SAMPLES,
    payload: {trackId, samples}
});

export const setTrackBrowsedPresets = (trackId, presets) => ({
    type: SET_TRACK_BROWSED_PRESETS,
    payload: {trackId, presets}
});

export const setBottomToolbarOffset = (off) => ({
    type: SET_BOTTOM_TOOLBAR_OFFSET,
    payload: off
});

export const setTrackUpdates = (updates) => ({
    type: SET_TRACK_UPDATES,
    payload: updates
});

export const setIsTranscribing = (isTranscribing) => ({
    type: SET_IS_TRANSCRIBING,
    payload: isTranscribing
});

export const setSampleTooltip = (sampleInfo) => ({
    type: SET_SAMPLE_TOOLTIP,
    payload: sampleInfo
});

export const setSelectedFreeze = (id) => ({
    type: SET_SELECTED_FREEZE,
    payload: id
});

export const setTrackLengthMode = (mode) => ({
    type: SET_TRACK_LENGTH_MODE,
    payload: mode
});

export const setTrackLengthChoice = (length) => ({
    type: SET_TRACK_LENGTH_CHOICE,
    payload: length
});

export const setFreezeDragging = (freeze) => ({
    type: SET_FREEZE_DRAGGING,
    payload: freeze
});

export const setFreezeColumnSamples = (trackId, column, samples) => ({
    type: SET_FREEZE_COLUMN_SAMPLES,
    payload: {
        trackId,
        column,
        samples
    }
});

export const setUploadingFile = (f) => ({
    type: SET_UPLOADING_FILE,
    payload: f
});

export const setGroupCollapsed = (subSequenceId, groupNumber, collapsed) => ({
    type: SET_GROUP_COLLAPSED,
    payload: {
        subSequenceId,
        groupNumber,
        collapsed
    }
});

export const setSelectedMixEffect = (subSequenceId, trackNumber, groupNumber, effectType, effect) => ({
    type: SET_SELECTED_MIX_EFFECT,
    payload: {
        subSequenceId,
        trackNumber,
        groupNumber,
        effectType,
        effect
    }
});

export const setSamplesDragging = (samples) => ({
    type: SET_SAMPLES_DRAGGING,
    payload: samples
});

export const setDisplayResolution = (resolution) => ({
    type: SET_DISPLAY_RESOLUTION,
    payload: resolution
});

export const setOfflineEngine = (offlineEngine) => ({
    type: SET_OFFLINE_ENGINE,
    payload: offlineEngine
});

export const setCurrentExportInfo = (name, index, total) => ({
    type: SET_CURRENT_EXPORT_INFO,
    payload: name === undefined ?
        undefined :
        {
            name, index, total
        }
});

export const setMixTrackDragging = (track) => ({
    type: SET_MIX_TRACK_DRAGGING,
    payload: track
});

export const setGroupTracks = (groupId, tracks) => ({
    type: SET_GROUP_TRACKS,
    payload: {
        groupId,
        tracks
    }
});

export const setLoadingText = (loadingText) => ({
    type: SET_LOADING_TEXT,
    payload: loadingText
});

export const setTrackEnvelopes = (id, envelopes) => ({
    type: SET_TRACK_ENVELOPES,
    payload:  {
        id, envelopes 
    }
});

export const setCopiedNodesForRack = (nodes) => ({
    type: SET_COPIED_NODES_FOR_RACK,
    payload: nodes
});

export const setLastMidiCCPlayed = (midiCC) => ({
    type: SET_LAST_MIDI_CC_PLAYED,
    payload: midiCC
});

export const setArrangementMouseDownX = (mouseX) => ({
    type: SET_ARRANGEMENT_MOUSE_DOWN_X,
    payload: mouseX
});

export const setTrackerParameterToEdit= (parameter) => ({
    type: SET_TRACKER_PARAMETER_TO_EDIT,
    payload: parameter
});

export const setTracksToHide = (tracks) => ({
    type: SET_TRACKS_TO_HIDE,
    payload: tracks
});

export const setSelectedPalette = (trackId, palette) => ({
    type: SET_SELECTED_PALETTE,
    payload: {trackId, palette}
});

export const setSequencedPalette = (trackId, palette) => ({
    type: SET_SEQUENCED_PALETTE,
    payload: {trackId, palette}
});


export const setProjectDragging = (project) => ({
    type: SET_PROJECT_DRAGGING,
    payload: project
});

export const setExploreUnpublished = (changed) => ({
    type: SET_EXPLORE_UNPUBLISHED,
    payload: changed
});

export const setQuickAddSearchText = (text) => ({
    type: SET_QUICK_ADD_SEARCH_TEXT,
    payload: text
});

export const setShowTrackFreezeHistory = (id, show) => ({
    type: SET_SHOW_TRACK_FREEZE_HISTORY,
    payload: {id, show}
});

export const setSelectedMidiTrack = (track) => ({
    type: SET_SELECTED_MIDI_TRACK,
    payload: track
});

export const setSelectedTrackSlice = (track, slice) => ({
    type: SET_SELECTED_TRACK_SLICE,
    payload: {
        track, slice
    }
});

export const setCirklonParameterSelected = (track, parameter) => ({
    type: SET_CIRKLON_PARAMETER_SELECTED,
    payload: {
        track,
        parameter
    }
});

export const setCirklonMode = (track, mode) => ({
    type: SET_CIRKLON_MODE,
    payload: {
        track,
        mode
    }
});

export const setNotesDown = (notes) => ({
    type: SET_NOTES_DOWN,
    payload: notes

});

export const setScenes = (scenes) => ({
    type: SET_SCENES,
    payload: scenes
});

export const setCurrentScene = (scene) => ({
    type: SET_CURRENT_SCENE,
    payload: scene
});

export const setShowSettings = (show) => ({
    type: SET_SHOW_SETTINGS,
    payload: show
});

export const setWallpaper  = (wallpaper) => ({
    type: SET_WALLPAPER,
    payload: wallpaper
});

export const setAnimateWallpaper  = (wallpaper) => ({
    type: SET_ANIMATE_WALLPAPER,
    payload: wallpaper
});

export const setExpandedProject = (project) => ({
    type: SET_EXPANDED_PROJECT,
    payload: project
});

export const setAccumulatorParameterSelected = (param) => ({
    type: SET_ACCUMULATOR_PARAMETER_SELECTED,
    payload: param
});

export const setPlaneMapping = (plane) => ({
    type: SET_PLANE_MAPPING,
    payload: plane
});

export const setTrackPresetSaving = (track) => ({
    type: SET_TRACK_PRESET_SAVING,
    payload: track
});

export const setSampleTagDragging = (tag) => ({
    type: SET_SAMPLE_TAG_DRAGGING,
    payload: tag
});

export const setParameterMixAutomations = (parameter, automations, scheduler) => ({
    type: SET_PARAMETER_MIX_AUTOMATIONS,
    payload: {
        parameter,
        automations,
        scheduler
    }
});

export const setShowArrangementTracks = (subSequenceId, show) => ({
    type: SET_SHOW_ARRANGEMENT_TRACKS,
    payload: {
        subSequenceId,
        show
    }
});

export const setArrangementPatternSelected = (pattern) => ({
    type: SET_ARRANGEMENT_PATTERN_SELECTED,
    payload: pattern
});

export const setSidebarSearchInput = (element) => ({
    type: SET_SIDEBAR_SEARCH_INPUT,
    payload: element
});

export const setShowArrangementSearcher = (show) => ({
    type: SET_SHOW_ARRANGEMENT_SEARCHER,
    payload: show
});

export const setExploreWork = (work) => ({
    type: SET_EXPLORE_WORK,
    payload: work
});

export const setCreatingNewPack = (creating) => ({
    type: SET_CREATING_NEW_PACK,
    payload: creating
});

export const setPackWindowPosition = (x,y) => ({
    type: SET_PACK_WINDOW_POSITION,
    payload: {x,y}
});

export const setDraggingPackWindow = (dragging) => ({
    type: SET_DRAGGING_PACK_WINDOW,
    payload: dragging
});

export const setPackToEdit = (pack) => ({
    type: SET_PACK_TO_EDIT,
    payload: pack
});

export const setIsManagingGuilds = (s) => ({
    type: SET_IS_MANAGING_GUILDS,
    payload: s
});

export const newStepGroup = (g) => ({
    type: NEW_STEP_GROUP,
    payload: g
});

export const setStepsGroupMode = (g) => ({
    type: SET_STEPS_GROUP_MODE,
    payload: g
});

export const setTransformationEdgeDragging= (tr) => ({
    type: SET_TRANSFORMATION_EDGE_DRAGGING,
    payload: tr
});

export const setShowFormantEffect = (formant) => ({
    type: SET_SHOW_FORMANT_EFFECT,
    payload: formant
});

export const setShowingFormants = (show) => ({
    type: SET_SHOWING_FORMANTS,
    payload: show
});

export const setPulledEffects = (effects) => ({
    type: SET_PULLED_EFFECTS,
    payload: effects
});

export const setLoopsToFreeze = (loops) => ({
    type: SET_LOOPS_TO_FREEZE,
    payload: loops
});

export const setParameterMinMax = (bulk) => ({
    type: SET_PARAMETER_MIN_MAX,
    payload: bulk
});

export const setCurrentSoundInList = (number) => ({
    type: SET_CURRENT_SOUND_IN_LIST,
    payload: number
});

export const setShowingSoundList = (show) => ({
    type: SET_SHOWING_SOUND_LIST,
    payload: show
});

export const setCurrentTagInList = (number) => ({
    type: SET_CURRENT_TAG_IN_LIST,
    payload: number
});

export const setLinkingEffects = (effect, name) => ({
    type: SET_LINKING_EFFECTS,
    payload: effect ? {
        effect,
        name
    } : undefined
});

export const setPackSelected = (number) => ({
    type: SET_PACK_SELECTED,
    payload: number
});

export const setSampleExplorerSelected = (f) => ({
    type: SET_SAMPLE_EXPLORER_SELECTED,
    payload: f
});

export const setPianoRollSlide = (f) => ({
    type: SET_PIANO_ROLL_SLIDE,
    payload: f
});

export const setMaximizeExplorer = (f) => ({
    type: SET_MAXIMIZE_EXPLORER,
    payload: f
});

export const setPads = (id, pads) => ({
    type: SET_PADS,
    payload: {
        id, pads
    }
});

export const setPadSlots = (id, slots) => ({
    type: SET_PAD_SLOTS,
    payload: {
        id, slots
    }
});

export const setPadHovered = (f) => ({
    type: SET_PAD_HOVERED,
    payload: f
});

export const setWaveformShowing = (f) => ({
    type: SET_WAVEFORM_SHOWING,
    payload: f
});

export const setTrackDragging = (f) => ({
    type: SET_TRACK_DRAGGING,
    payload: f
});

export const setHideMixer = (h) => ({
    type: SET_HIDE_MIXER,
    payload: h
});

export const setSourceExploring = (h) => ({
    type: SET_SOURCE_EXPLORING,
    payload: h
});

export const setYearExploring = (year) => ({
    type: SET_YEAR_EXPLORING,
    payload: year
});

export const setPullablePartDragging = (part) => ({
    type: SET_PULLABLE_PART_DRAGGING,
    payload: part
});

export const setPadsExpand = (id) => ({
    type: SET_PADS_EXPAND,
    payload: id
});

export const setSequencers = (id, sequencers) => ({
    type: SET_SEQUENCERS,
    payload: {id, sequencers}
});

export const setSequencerTracks = (id, tracks) => ({
    type: SET_SEQUENCER_TRACKS,
    payload: {id, tracks}
});

export const setPlaneMacros = (id, macros) => ({
    type: SET_PLANE_MACROS,
    payload: {id, macros}
});

export const setWindowPosition = (id, position) => ({
    type: SET_WINDOW_POSITION,
    payload: {id, position}
});

export const setPadEffects = (id, effects) => ({
    type: SET_PAD_EFFECTS,
    payload: {id, effects}
});

export const setDrawingPadEdge = (id, edge) => ({
    type: SET_DRAWING_PAD_EDGE,
    payload: {id, edge}
});

export const setSelectedPadEdge  = (edge) => ({
    type: SET_SELECTED_PAD_EDGE,
    payload: edge
});

export const setBulkEffectsCollapsed = (x) => ({
    type: SET_BULK_EFFECTS_COLLAPSED,
    payload: x
});

export const setSelectedPulledElements = (x) => ({
    type: SET_SELECTED_PULLED_ELEMENTS,
    payload: x
});

export const setBulkWindowPositions = (bulk) => ({
    type: SET_BULK_WINDOW_POSITIONS,
    payload: bulk
});

export const setAllEffectPatternLocks = (bulk) => ({
    type: SET_ALL_EFFECT_PATTERN_LOCKS,
    payload: bulk
});

export const setModuleCollapsed = (id, collapsed) => ({
    type: SET_MODULE_COLLAPSED,
    payload: {
        id, collapsed
    }
});

export const setTrackMidiEffects = (id, effects) => ({
    type: SET_TRACK_MIDI_EFFECTS,
    payload: {
        id, effects
    }
});

export const setEffectStarred = (id, starred) => ({
    type: SET_EFFECT_STARRED,
    payload: {
        id, starred
    }
});

export const setBulkEffectsStarred = (bulk) => ({
    type: SET_BULK_EFFECTS_STARRED,
    payload: bulk
});

export const setBulkModulesCollapsed = (bulk) => ({
    type: SET_BULK_MODULES_COLLAPSED,
    payload: bulk
});

export const deleteTrackId = (id) => ({
    type: DELETE_TRACK_ID,
    payload: id
});
